export default __webpack_public_path__ + "static/media/GM_homepage.83f5d012.jpg";